import { render } from "./SortableList.vue?vue&type=template&id=32df96de&scoped=true"
import script from "./SortableList.vue?vue&type=script&lang=js"
export * from "./SortableList.vue?vue&type=script&lang=js"

import "./SortableList.vue?vue&type=style&index=0&id=32df96de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df96de"]])

export default __exports__